export const lineHeightVariants = {
  'line-height': {
    3: 'leading-3',
    4: 'leading-4',
    5: 'leading-5',
    6: 'leading-6',
    7: 'leading-7',
    8: 'leading-8',
    9: 'leading-9',
    10: 'leading-10',
    none: 'leading-none',
    tight: 'leading-tight',
    snug: 'leading-snug',
    normal: 'leading-normal',
    relaxed: 'leading-relaxed',
    loose: 'leading-loose',
    xs: 'leading-xs',
    sm: 'leading-sm',
    md: 'leading-md',
    lg: 'leading-lg',
    xl: 'leading-xl',
    '2xl': 'leading-2xl',
    '3xl': 'leading-3xl',
  },
  'line-height-sm': {
    3: 'sm:leading-3',
    4: 'sm:leading-4',
    5: 'sm:leading-5',
    6: 'sm:leading-6',
    7: 'sm:leading-7',
    8: 'sm:leading-8',
    9: 'sm:leading-9',
    10: 'sm:leading-10',
    none: 'sm:leading-none',
    tight: 'sm:leading-tight',
    snug: 'sm:leading-snug',
    normal: 'sm:leading-normal',
    relaxed: 'sm:leading-relaxed',
    loose: 'sm:leading-loose',
    xs: 'sm:leading-xs',
    sm: 'sm:leading-sm',
    md: 'sm:leading-md',
    lg: 'sm:leading-lg',
    xl: 'sm:leading-xl',
    '2xl': 'sm:leading-2xl',
    '3xl': 'sm:leading-3xl',
  },
  'line-height-md': {
    3: 'md:leading-3',
    4: 'md:leading-4',
    5: 'md:leading-5',
    6: 'md:leading-6',
    7: 'md:leading-7',
    8: 'md:leading-8',
    9: 'md:leading-9',
    10: 'md:leading-10',
    none: 'md:leading-none',
    tight: 'md:leading-tight',
    snug: 'md:leading-snug',
    normal: 'md:leading-normal',
    relaxed: 'md:leading-relaxed',
    loose: 'md:leading-loose',
    xs: 'md:leading-xs',
    sm: 'md:leading-sm',
    md: 'md:leading-md',
    lg: 'md:leading-lg',
    xl: 'md:leading-xl',
    '2xl': 'md:leading-2xl',
    '3xl': 'md:leading-3xl',
  },
  'line-height-lg': {
    3: 'lg:leading-3',
    4: 'lg:leading-4',
    5: 'lg:leading-5',
    6: 'lg:leading-6',
    7: 'lg:leading-7',
    8: 'lg:leading-8',
    9: 'lg:leading-9',
    10: 'lg:leading-10',
    none: 'lg:leading-none',
    tight: 'lg:leading-tight',
    snug: 'lg:leading-snug',
    normal: 'lg:leading-normal',
    relaxed: 'lg:leading-relaxed',
    loose: 'lg:leading-loose',
    xs: 'lg:leading-xs',
    sm: 'lg:leading-sm',
    md: 'lg:leading-md',
    lg: 'lg:leading-lg',
    xl: 'lg:leading-xl',
    '2xl': 'lg:leading-2xl',
    '3xl': 'lg:leading-3xl',
  },
  'line-height-xl': {
    3: 'xl:leading-3',
    4: 'xl:leading-4',
    5: 'xl:leading-5',
    6: 'xl:leading-6',
    7: 'xl:leading-7',
    8: 'xl:leading-8',
    9: 'xl:leading-9',
    10: 'xl:leading-10',
    none: 'xl:leading-none',
    tight: 'xl:leading-tight',
    snug: 'xl:leading-snug',
    normal: 'xl:leading-normal',
    relaxed: 'xl:leading-relaxed',
    loose: 'xl:leading-loose',
    xs: 'xl:leading-xs',
    sm: 'xl:leading-sm',
    md: 'xl:leading-md',
    lg: 'xl:leading-lg',
    xl: 'xl:leading-xl',
    '2xl': 'xl:leading-2xl',
    '3xl': 'xl:leading-3xl',
  },
}
